/**
 * Schema for saveOrder endpoint
 */

import { z } from "zod";

export const saveOrderSchema = z.object({
  id: z.number().nullable(),
  code: z.string(),
  company: z.object({
    id: z.number()
  }),
  customer: z.object({
    id: z.number()
  }),
  enable: z.boolean(),
  qtyTransported: z.union([z.number(), z.literal("")]),
  sendEmail: z.boolean(),
  orderItem: z.array(
    z.object({
      id: z.number().nullable(),
      product: z.object({
        id: z.number(),
        name: z.string()
      }),
      quantity: z.number()
    })
  ),
  shippingCompany: z.array(
    z.object({
      id: z.number()
    })
  )
});
